import { IGameIdentity } from "motw_core/Entity/IGameIdentity";
import { IGameIdentityGoal } from "motw_core/Entity/IGameIdentityGoal";
import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { resourceNameGameIdentityGoal } from "../../../../../../../../motw_core/Entity/IGameIdentityGoal";
import { IGoalsContainerState } from "../../../Goals/IGoalsState";
import { GoalNamesSelector } from "./GoalNamesSelector/GoalNamesSelector";
import { IdentityGoalNames } from "./IdentityGoalNames";
import { IGameIdentityDTO } from "../../../../../../../../motw_core/DTOs/IGameIdentityDTO";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";

export function IdentityGoals({
    identity,
    goalNamesLoggedToday,
}: {
    identity: IGameIdentityDTO;
    goalNamesLoggedToday: string[];
}) {
    const [gameIdentityGoals, setGameIdentityGoals] = React.useState<
        IGameIdentityGoal[]
    >([]);

    React.useEffect(() => {
        ClientDataProvider.GetRecordsAsync<IGameIdentityGoal>(
            resourceNameGameIdentityGoal
        ).then((result) => setGameIdentityGoals(result));
    }, []);

    const [goals, setGoals] = React.useState<IGoal[]>([]);

    React.useEffect(() => {
        const goalsContainer = State.ReadClass<IGoalsContainerState>(
            ESharedComponent.GoalsContainer
        );

        if (goalsContainer) {
            setGoals(goalsContainer.state.Goals);
        }
    }, []);

    return (
        <div
            {...Style(`identityGoals`, {
                margin: `5px 5px`,
            })}
        >
            <IdentityGoalNames
                gameIdentityGoals={gameIdentityGoals}
                allGoals={goals}
                identity={identity}
                goalNamesLoggedToday={goalNamesLoggedToday}
            />
            <GoalNamesSelector
                identity={identity}
                allGoals={goals}
                goalNamesLoggedToday={goalNamesLoggedToday}
            />
        </div>
    );
}
